import { useState } from 'react'
import { ColorPicker as AntColorPicker } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import type { Color } from 'antd/es/color-picker'

interface ColorPickerProps {
  value: string
  onChange: (color: string) => void
}

const PRESET_COLORS = [
  '#111827', '#EF4444', '#F97316', '#F59E0B', '#EAB308',
  '#84CC16', '#22C55E', '#10B981', '#14B8A6', '#06B6D4',
  '#0EA5E9', '#3B82F6', '#6366F1', '#8B5CF6', '#A855F7',
  '#D946EF', '#EC4899', '#F43F5E'
]

export default function ColorPicker({ value, onChange }: ColorPickerProps) {
  const handleChange = (color: Color) => {
    onChange(color.toHexString().toUpperCase())
  }
  const [open, setOpen] = useState(false);

  return (
    <AntColorPicker
      value={value}
      onChange={handleChange}
      presets={[
        {
          label: 'Recommended',
          colors: PRESET_COLORS
        }
      ]}
      open={open}
      onOpenChange={setOpen}
      showText={() => (
          <DownOutlined
            rotate={open ? 180 : 0}
            style={{
              color: 'rgba(0, 0, 0, 0.25)',
            }}
          />
        )}
      format="hex"
      size="small"
      className="rounded-none"
    />
  )
}
